import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Badge } from '@sola/ark-core/atoms/badge/badge.tsx';
import { Link } from '@sola/ark-core/atoms/link/link.tsx';
import { getChildBioPath } from '@sola/my-sdk/constants.ts';
import type { GraphQLCommitment } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { PolaroidImage } from '../../atoms/polaroid-image/polaroid-image.tsx';
import { AffinityCardGraphic, AffinityCardInteractive, AffinityCardStat, AffinityCardStats, AffinityCardSummary } from '../affinity-card/affinity-card.tsx';
import { useAffinityCardSponsorship } from './affinity-card-sponsorship.logic.ts';
export type AffinityCardSponsorshipProps = {
  commitment: GraphQLCommitment;
};
export const AffinityCardSponsorship: React.FC<AffinityCardSponsorshipProps> = t0 => {
  const $ = _c(32);
  const {
    commitment
  } = t0;
  const {
    t,
    globalId,
    childName,
    photoUrl,
    birthdate,
    startDate,
    summary,
    isCorrespondent,
    lastWrittenDays
  } = useAffinityCardSponsorship(commitment);
  let t1;
  if ($[0] !== globalId) {
    t1 = getChildBioPath(globalId);
    $[0] = globalId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== childName || $[3] !== photoUrl) {
    t2 = photoUrl && <PolaroidImage childImageUrl={photoUrl} alt={childName ?? ""} />;
    $[2] = childName;
    $[3] = photoUrl;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <AffinityCardGraphic align="center">{t2}</AffinityCardGraphic>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = childName ?? "";
  let t5;
  if ($[7] !== isCorrespondent || $[8] !== t) {
    t5 = isCorrespondent ? <Badge label={t("my:sponsorshipRelationship.correspondent")} iconBefore="mail-04" size="sm" /> : undefined;
    $[7] = isCorrespondent;
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== summary || $[11] !== t4 || $[12] !== t5) {
    t6 = <AffinityCardSummary title={t4} badge={t5} summary={summary} />;
    $[10] = summary;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== birthdate || $[15] !== t) {
    t7 = birthdate && <AffinityCardStat title={t("my:homepage.affinityCard.sponsorship.birthday")} stat={t("my:homepage.affinityCard.sponsorship.birthdayValue", {
      date: birthdate
    })} />;
    $[14] = birthdate;
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== startDate || $[18] !== t) {
    t8 = startDate && <AffinityCardStat title={t("my:homepage.affinityCard.sponsorship.sponsoredSince")} stat={t("my:homepage.affinityCard.sponsorship.sponsoredSinceValue", {
      date: new Date(startDate)
    })} />;
    $[17] = startDate;
    $[18] = t;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== lastWrittenDays || $[21] !== t) {
    t9 = typeof lastWrittenDays === "string" && <AffinityCardStat title={t("my:homepage.affinityCard.sponsorship.lastWritten")} stat={lastWrittenDays} />;
    $[20] = lastWrittenDays;
    $[21] = t;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
    t10 = <AffinityCardStats>{t7}{t8}{t9}</AffinityCardStats>;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t1 || $[28] !== t10 || $[29] !== t3 || $[30] !== t6) {
    t11 = <AffinityCardInteractive><Link href={t1}>{t3}{t6}{t10}</Link></AffinityCardInteractive>;
    $[27] = t1;
    $[28] = t10;
    $[29] = t3;
    $[30] = t6;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
};